import { ContextWrapper } from "@common/contexts";
import { HospitalPrescriptionStore } from "@hospital/stores/HospitalPrescriptionStore";
import React, { useContext, useEffect, useMemo, useState } from "react";

export const HospitalPrescriptionStoreContext = new ContextWrapper<HospitalPrescriptionStore>();

/**
 * Create a Hospital Prescription store
 * @param
 * @returns
 */
export const useCreateHospitalPrescriptionStore = (options?: { shouldSetContext?: boolean }) => {
    const [shouldSetContext, setShouldSetContext] = useState<boolean>(Boolean(options?.shouldSetContext));

    useEffect(() => {
        if (options)
            setShouldSetContext(Boolean(options.shouldSetContext));
    }, [options])

    const [hospitalPrescriptionStore] = useMemo(() => {
        const store = new HospitalPrescriptionStore();
        if (shouldSetContext)
            HospitalPrescriptionStoreContext.set(store);
        return [store];
    }, [shouldSetContext])
    return hospitalPrescriptionStore;
}

export const useHospitalPrescriptionStore = () => {
    return useContext(HospitalPrescriptionStoreContext.get() ?? React.createContext(new HospitalPrescriptionStore()));
}
